var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.site.NavBar.props.content)?_c('NavBar',{attrs:{"content":_vm.site.NavBar.props.content}}):_vm._e(),_c('router-view'),(_vm.site.NavBar.props.content)?_c('FooterBar',{attrs:{"content":_vm.site.FooterBar.props.content}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }